var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modalBody fRow jCenter aCenter"},[_c('div',{staticClass:"modalCloser",on:{"click":_vm.closeIt}}),_c('div',{staticClass:"modalSlot aCenter jCenter fCol"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }